import React from 'react';
import { makeStyles } from '@material-ui/core';
import { BaseCardField, BaseCheckboxWithLabel } from '../../../common';
import { IMedium } from 'src/api/base/Auth/types';
import { getArrWithNewEl } from 'src/utils/helpers';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '-10px 0 0 -10px',
  },
  fieldCard: {
    padding: '10px',
  },
  field: {
    margin: '10px 0 0 10px',
  },
}));

type PMediumCheckboxes = {
  loading?: boolean;
  value: Array<number>;
  data: Array<IMedium>;
  onChange: any;
  errorText?: any;
  label: any;
  offCardStyles?: boolean;
  className?: any;
};

export const AvailableForCheckboxes: React.FC<PMediumCheckboxes> = (props) => {
  const {
    loading,
    data,
    value,
    onChange,
    errorText,
    label,
    offCardStyles = true,
    className,
  } = props;
  const classes = useStyles(props);

  const handleOnChange = (id: number) => {
    onChange(getArrWithNewEl(value, id));
  };

  return (
    <BaseCardField
      label={label}
      loading={loading}
      errorText={errorText}
      cardOptions={{
        offCardStyles,
        className: clsx(classes.fieldCard, className, 'custom-box'),
      }}
    >
      <div className={classes.root}>
        {data.map((item) => {
          return (
            <div className={classes.field} key={item.id}>
              <BaseCheckboxWithLabel
                label={item.name}
                value={item.id}
                key={item.id}
                checked={value.includes(item.id)}
                onChange={() => {
                  handleOnChange(item.id);
                }}
              />
            </div>
          );
        })}
      </div>
    </BaseCardField>
  );
};
